import React, { ReactElement, FunctionComponent, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { TestID } from '../../../utils/PropTypesDefinitions'
import { BackgroundColorTypes } from '../../../Theme/Fonts/FontTypes'

const CardStart: FunctionComponent<TestID & { backgroundColor?: BackgroundColorTypes }> = ({
    testID,
    backgroundColor = 'moon',
}): ReactElement => {
    return (
        <Grid noExpand height={1} maxHeight={1} backgroundColor={backgroundColor} testID={testID} />
    )
}

export default memo(CardStart)
